import { render, staticRenderFns } from "./addstaff.vue?vue&type=template&id=0e7b0499&scoped=true&"
import script from "./addstaff.vue?vue&type=script&lang=js&"
export * from "./addstaff.vue?vue&type=script&lang=js&"
import style0 from "./addstaff.vue?vue&type=style&index=0&id=0e7b0499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b0499",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCardText,VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
